import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.038 31.403v-8.78a1.5 1.5 0 10-3 0v8.78a1.5 1.5 0 003 0z" /><path d="M12.938 31.4V15.588a1.5 1.5 0 00-3 0V31.4a1.5 1.5 0 003 0zM22.911 31.42V8.47a1.5 1.5 0 10-3 0V31.42a1.5 1.5 0 103 0zM32.904 31.438V1.644a1.5 1.5 0 00-3 0v29.794a1.5 1.5 0 003 0z" opacity=".2" /></svg>;